import { FascicoloLight } from '../../../models/fascicolo/fascicolo-light';
import { CampiIntestazione } from '../../../models/pratica/intestazione-pratica/campi-intestazione';
import { Intestazione } from '../../../models/pratica/intestazione-pratica/intestazione';
import { PraticaBase } from '../../../models/pratica/pratica-base';

export class FascicoloFullAdapter extends FascicoloLight {
  praticaBase: PraticaBase;

  constructor(fascicoloLight: FascicoloLight, pratica: PraticaBase) {
    super();
    this.id = fascicoloLight.id;
    this.idParent = fascicoloLight.idParent;
    this.tipoFascicolo = fascicoloLight.tipoFascicolo;
    this.stato = fascicoloLight.stato;
    this.dataDefinizione = fascicoloLight.dataDefinizione;
    this.motivoDefinizione = fascicoloLight.motivoDefinizione;
    this.definito = fascicoloLight.definito;
    this.grado = fascicoloLight.grado;
    this.posizione = fascicoloLight.posizione;
    this.vecchiaPosizione = fascicoloLight.vecchiaPosizione;
    this.flagProcessoTelematico = fascicoloLight.flagProcessoTelematico;
    this.flagFondoRischi = fascicoloLight.flagFondoRischi;
    this.dataVariazioneFondoRischi = fascicoloLight.dataVariazioneFondoRischi;
    this.natura = fascicoloLight.natura;
    this.dataInizioFascicolo = fascicoloLight.dataInizioFascicolo;
    this.note = fascicoloLight.note;
    this.registroFascicolo = fascicoloLight.registroFascicolo;
    this.praticaBase = new PraticaBase();
    this.praticaBase.intestazione = new Intestazione();
    this.praticaBase.intestazione.campi = new CampiIntestazione();
    this.praticaBase.intestazione.campi.tipoPratica = pratica.tipoPratica.id;
    this.praticaBase.id = pratica.id;
    this.praticaBase.tipoPratica = pratica.tipoPratica;
    this.praticaBase.stato = pratica.stato;
    this.praticaBase.correlata = pratica.correlata;
    this.praticaBase.definito = pratica.definito;
    this.praticaBase.capofila = pratica.capofila;
    this.praticaBase.riunita = pratica.riunita;
    this.praticaBase.motivoDefinizione = pratica.motivoDefinizione;
    this.praticaBase.dataDefinizione = pratica.dataDefinizione;
    this.praticaBase.dataArchiviazione = pratica.dataArchiviazione;
    this.praticaBase.posizione = pratica.posizione;
    this.praticaBase.vecchiaPosizione = pratica.vecchiaPosizione;
    this.praticaBase.note = pratica.note;
    this.praticaBase.dataApertura = pratica.dataApertura;
    this.praticaBase.soggetto = pratica.soggetto;
    this.praticaBase.archiviata = pratica.archiviata;
    this.riassunto = fascicoloLight.riassunto;
    this.intestazione = fascicoloLight.intestazione;

  }
}
